module.exports = __webpack_public_path__ + "img/slika3.c62ce5aa.jpg";